import { dynamicImport } from '@canvas/dynamic-import';
import { preloader, PreloaderPriority } from '@canvas/preloader';

// Preload all lazy-loaded components
export const initializePreloaders = () => {
  preloader.scheduleAll({
    DatabaseSnackbar: {
      task: () => dynamicImport(() => import('@databases/snackbar/DatabaseSnackbar')),
      priority: PreloaderPriority.LOW
    },
    DevtoolsPanel: {
      task: () => dynamicImport(() => import('@databases/devtools')),
      priority: PreloaderPriority.LOW
    },
    ExportDialog: {
      task: () => dynamicImport(() => import('@databases/export/ExportDialog')),
      priority: PreloaderPriority.LOW
    },
    ImportDialog: {
      task: () => dynamicImport(() => import('@databases/import-ui/ImportDialog')),
      priority: PreloaderPriority.LOW
    },
    DatabaseSetupPanel: {
      task: () => dynamicImport(() => import('@databases/database-setup')),
      priority: PreloaderPriority.LOW
    },
    DuplicateDatabasePanelContainer: {
      task: () =>
        // FIXME circular dependency
        // eslint-disable-next-line workspaces/require-dependency
        dynamicImport(() => import('@databases/duplicate-database-panel/PanelContainer')),
      priority: PreloaderPriority.LOW
    },
    FieldSettingsDialog: {
      task: () =>
        dynamicImport(
          () => import('../apps/field-settings-dialog/components/FieldSettingsDialog.tsx')
        ),
      priority: PreloaderPriority.LOW
    },
    DatabaseEntryPanel: {
      task: () =>
        dynamicImport(
          () => import('../apps/database-entry-dialog/components/DatabaseEntryPanel.tsx')
        ),
      priority: PreloaderPriority.LOW
    },
    CreateFieldPanel: {
      task: () =>
        dynamicImport(
          () => import('../apps/create-field-dialog/components/CreateFieldPanel.tsx')
        ),
      priority: PreloaderPriority.LOW
    }
  });
};
